/**
 * The practice name for "The <name> Team": a leading "The" is dropped so "The Smile Clinic" signs off
 * "The Smile Clinic Team". A name that is only "The" is kept. Same rule as the server's utils/groupNames.js.
 */
export function teamName(name: string | null | undefined): string {
  const trimmed = String(name || '').trim();
  return trimmed.replace(/^the\s+/i, '').trim() || trimmed;
}
